export default __webpack_public_path__ + "static/media/beep.b50a4155.wav";